import { ReactNode } from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotifyState {
  visible: boolean;
  message: string | ReactNode;
  status?: 'success' | 'info' | 'warning' | 'error';
}

export const initialState: NotifyState = {
  visible: false,
  message: '',
  status: 'info'
};

export interface ActionType extends NotifyState {
  type: string;
}

export const notifySlice = createSlice({
  name: 'notify',
  initialState,
  reducers: {
    SET_NOTIFY_VISIBLE: (state, action: PayloadAction<NotifyState>) => {
      return {
        ...state,
        ...action.payload
      };
    }
  }
});

export const { SET_NOTIFY_VISIBLE } = notifySlice.actions;

export default notifySlice.reducer;
